
<script>
import defaultAdd from './DefaultAdd'
export default {
  name: 'socialWechatMenuDefaultDetail',
  extends: defaultAdd,
  data () {
    return {

    }
  }
}
</script>
